import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { getWechatConfig, wechatAuth } from "@api/public";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";
import dialog from "@utils/dialog";
const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
const LOGINTYPE = "loginType";
let instance;
let wechatObj;
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";

const WECHAT_SCRIPT_URL = "//res.wx.qq.com/open/js/jweixin-1.6.0.js";

export default function wechat() {
  console.log("jinru wechat");
  return new Promise((resolve, reject) => {
    console.log("jinru pro");
    console.log(instance);
    if (instance) return resolve(instance);
    console.log(getWechatConfig());
    getWechatConfig()
      .then(res => {
        console.log("jinru config");
        console.log(res);
        console.log(WECHAT_SCRIPT_URL);
        res.data.customUrl = WECHAT_SCRIPT_URL;
        const _wx = WechatJSSDK(res.data);
        wechatObj = _wx;
        console.log(_wx.initialize());
        _wx
          .initialize()
          .then(() => {
            console.log("jinru init");
            instance = _wx.wx;
            instance.initConfig = res.data;
            resolve(instance);
          })
          .catch(() => {
            console.log("shibai int");
            reject;
          });
      })
      .catch(err => {
        console.log(err);
        reject(err);
      });
  });
}

export function clearAuthStatus() {
  cookie.remove(WX_AUTH);
  cookie.remove(STATE_KEY);
}

export function oAuth() {
  console.log("onshangle");
  if (cookie.has(WX_AUTH) && store.state.app.token) return;
  const { code } = parseQuery();
  console.log("code是什么");
  console.log(code);
  if (!code) {
    console.log("not bad");
    return toAuth();
  }
}

export function auth(code) {
  /*
  return new Promise((resolve, reject) => {
    let loginType = cookie.get(LOGINTYPE);
    //if (state !== cookie.get(STATE_KEY)) return reject();
    wechatAuth(code, parseInt(cookie.get("spread")), loginType)
      .then(({ data }) => {
        const expires_time = dayjs(data.expires_time);
        const newTime = Math.round(new Date() / 1000);
        store.commit("LOGIN", data.token, expires_time - newTime);
        cookie.set(WX_AUTH, code);
        cookie.remove(STATE_KEY);
        loginType && cookie.remove(LOGINTYPE);
        
    console.log(data);
    resolve(data);
      })
      .catch(({ err }) =>{
    console.log(err);
    });
  });
  */
  /*
  return new Promise((resolve, reject) => {
      let loginType = cookie.get(LOGINTYPE);
      wechatAuth(code, parseInt(Cache.get("spread")))
        .then(({
          data
        }) => {
          // store.commit("LOGIN", {
          //  token: data.token,
          //  time: Cache.strTotime(data.expires_time) - Cache.time()
          // });
          // store.commit("SETUID", data.userInfo.uid);
          cookie.set(WX_AUTH, code);
          cookie.clear(STATE_KEY);
          resolve(data);
        })
        .catch(reject);
    });

  */
  return new Promise((resolve, reject) => {
    let loginType = cookie.get(LOGINTYPE);
    //if (state !== cookie.get(STATE_KEY)) return reject();
	console.log('这是code')
	console.log(code)
	console.log(loginType)
    wechatAuth(code, parseInt(cookie.get("spread")), loginType)
      .then(({ data }) => {
		console.log(data)
        const expires_time = dayjs(data.expires_time);
        const newTime = Math.round(new Date() / 1000);
        store.commit("LOGIN", data.token, expires_time - newTime);
        cookie.set(WX_AUTH, code, expires_time);
        cookie.remove(STATE_KEY);
        loginType && cookie.remove(LOGINTYPE);
        resolve();
      })
      .catch(reject);
  });
}

export function toAuth() {
  console.log("to auth");
  wechat()
    .then(wx => {
      console.log("wx");
      console.log(wx);
      console.log("url");
      console.log(getAuthUrl(wx.initConfig.appId));
      location.href = getAuthUrl(wx.initConfig.appId);
      auth();
    })
    .catch(e => {
      console.log("meine");
      console.log(e);
      dialog.error("授权失败,请重新尝试");
    });
}

function getAuthUrl(appId) {
  const redirect_uri = encodeURIComponent(
    `${location.origin}/auth/` +
      encodeURIComponent(
        encodeURIComponent(
          cookie.has(BACK_URL)
            ? cookie.get(BACK_URL)
            : location.pathname + location.search
        )
      )
  );
  cookie.remove(BACK_URL);
  const state = encodeURIComponent(
    ("" + Math.random()).split(".")[1] + "authorizestate"
  );
  cookie.set(STATE_KEY, state);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
}

// function toPromise(fn, config = {}) {
//   return new Promise((resolve, reject) => {
//     fn({
//       ...config,
//       success(res) {
//         resolve(res);
//       },
//       fail(err) {
//         reject(err);
//       },
//       complete(err) {
//         reject(err);
//       },
//       cancel(err) {
//         reject(err);
//       }
//     });
//   });
// }

// 重新支付接口控件
function toOpenPay(config) {
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", toOpenPay, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", toOpenPay);
      document.attachEvent("onWeixinJSBridgeReady", toOpenPay);
    }
  } else {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: config.appId, //公众号名称，由商户传入
          timeStamp: config.timestamp, //时间戳，自 1970 年以来的秒数
          nonceStr: config.nonceStr, //随机串
          package: config.package,
          signType: config.signType, //微信签名方式：
          paySign: config.paySign //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // window.confirm("付款成功");
            resolve(res);
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            // window.confirm("付款失败");
            reject(res);
          }
        }
      );
    });
  }
}
// 微信支付
export function pay(config) {
  return toOpenPay(config);
  // return toPromise(instance.chooseWXPay, config);
}

export function openAddress() {
  return new Promise((resolve, reject) => {
    wechatEvevt("openAddress", {})
      .then(res => {
        console.log("wechatEvent成功");
        resolve(res);
      })
      .catch(res => {
        if (res.is_ready) {
          res.wx.openAddress({
            fail(res) {
              reject(res);
            },
            success(res) {
              resolve(res);
            }
          });
        } else {
          reject(res);
        }
      });
  });
}

export function openShareAll(config) {
  config || {};
  config.type = config.type == undefined ? "link" : config.type;
  return new Promise(resolve => {
    getWechatConfig().then(res => {
      wechatObj.signSignature({
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        timestamp: res.data.timestamp
      });
      instance = wechatObj.getOriginalWx();
      instance.ready(() => {
        console.log("instance");
        console.log(instance);
        console.log(config);
        instance.updateAppMessageShareData(config);
        instance.updateTimelineShareData(config);
        resolve();
      });
    });
  });
}

export function openShareAppMessage(config) {
  instance.updateAppMessageShareData(config);
  instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

export function openShareTimeline(config) {
  instance.updateTimelineShareData(config);
  instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

/**
 * 公众号事件
 * @param name 事件名
 * @param config 配置
 * @returns {Promise<unknown>}
 */
export function wechatEvevt(name, config) {
  return new Promise((resolve, reject) => {
    let wx;
    let configDefault = {
      fail(res) {
        console.log("进入configDefault失败");
        console.log(res);
        if (wx) return reject({ is_ready: true, wx: wx });
        getWechatConfig().then(res => {
          const _wx = WechatJSSDK(res.data);
          wechatObj = _wx;
          wechatObj.signSignature({
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            timestamp: res.data.timestamp
          });
          wx = wechatObj.getOriginalWx();
          reject({ is_ready: true, wx: wx });
        });
      },
      success(res) {
        console.log("有没有进入configDefault的success", res);
        //resolve(res);
      }
    };
    Object.assign(configDefault, config);
    getWechatConfig().then(res => {
      console.log("JSSDK之前");
      console.log(res.data);
      const _wx = WechatJSSDK(res.data);
      console.log("JSSDK之后");
      _wx.debug = false;
      console.log(_wx);
      _wx.initialize().then(() => {
        console.log("init还是不行吗");
        instance = _wx.getOriginalWx();
        console.log("instance是什么");
        console.log(instance);
        instance.ready(() => {
          console.log("instance的ready进来了");
          if (typeof name === "object") {
            name.forEach(item => {
              instance[item] && instance[item](configDefault);
            });
          } else {
            console.log("进入else并name是：" + name);
            console.log("最终句的结果是");
            console.log("看看参数configDefault是什么");
            console.log(configDefault);
            console.log("最终openAddress结果");
            console.log(instance[name](configDefault));
            instance[name] && instance[name](configDefault);
            //执行openAddress是Undefined
          }
        });
      });
    });
  });
}

export function ready() {
  return new Promise(resolve => {
    if (typeof instance !== "undefined") {
      instance.ready(() => {
        resolve(instance);
      });
    } else {
      getWechatConfig().then(res => {
        const _wx = WechatJSSDK(res.data);
        _wx.initialize().then(() => {
          instance = _wx.wx;
          instance.ready(() => {
            resolve(instance);
          });
        });
      });
    }
  });
}

export function wxShowLocation() {
  return new Promise((resolve, reject) => {
    let longitude = cookie.get(LONGITUDE); //经度
    let latitude = cookie.get(LATITUDE); //纬度
    if (longitude && latitude) {
      return resolve({ longitude: longitude, latitude: latitude });
    }
    wechatEvevt("getLocation", { type: "wgs84" })
      .then(res => {
        let latitude = res.latitude; // 纬度
        let longitude = res.longitude; // 经度
        cookie.set(LATITUDE, latitude);
        cookie.set(LONGITUDE, longitude);
        resolve(res);
      })
      .catch(res => {
        if (res.is_ready) {
          res.wx.getLocation({
            success(res) {
              let latitude = res.latitude; // 纬度
              let longitude = res.longitude; // 经度
              cookie.set(LATITUDE, latitude);
              cookie.set(LONGITUDE, longitude);
              resolve(res);
            },
            cancel(res) {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              reject(res);
              dialog.error("取消获取位置");
            },
            fail(res) {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              reject(res);
              dialog.error("授权失败");
            }
          });
        }
      });
  });
}
